// extracted by mini-css-extract-plugin
export var blocksContainer = "SummaryBlocks-module--blocksContainer--c12be";
export var container = "SummaryBlocks-module--container--4275e";
export var title = "SummaryBlocks-module--title--cbe67";